import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import {
  canCreateSpaces,
  canManageSpaceGroups,
} from "@circle-react/helpers/spaceGroupHelpers";

import type { SpaceGroupWithSpaces } from "../../Sidebar";

export const useSpaceGroupAccessControl = (
  spaceGroup: SpaceGroupWithSpaces,
) => {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const canCreateSpace = Boolean(canCreateSpaces({ spaceGroup }));
  const canManage = Boolean(canManageSpaceGroups({ spaceGroup }));
  const canAdd = canCreateSpace || isAdmin;

  return {
    canAdd,
    canCreateSpace,
    canManage,
    isAdmin,
  };
};
